// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable multiline-comment-style */

import { ReactNode } from "react"

export type Notice = null | {
  id: string
  type: "info" | "success" | "warning" | "critical"
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line no-undef, @typescript-eslint/no-explicit-any
  icon: boolean | React.ReactElement<any>
  closable: boolean
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  onClose: () => void | null | undefined
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line no-undef, @typescript-eslint/no-explicit-any
  title: React.ReactElement<React.ComponentProps<React.ComponentType<any>>> | string
  content: ReactNode
  ttl: number | null | undefined
}

type NoticeSetAction = {
  type: "notice/SET"
  notice: Notice
}

type NoticeClearAction = {
  type: "notice/CLEAR"
  id: string | null | undefined
}

type NoticeAction = NoticeSetAction | NoticeClearAction

const NOTICE_SET = "notice/SET"
const NOTICE_CLEAR = "notice/CLEAR"

export default function NoticeReducer(state: Notice, action: NoticeAction) {
  switch (action.type) {
    case NOTICE_SET:
      return action.notice
    case NOTICE_CLEAR:
      return !action.id || (state && action.id === state.id) ? null : state
    default:
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      return state || null
  }
}

type NoticeOptions = {
  id: string
  type?: "info" | "success" | "warning" | "critical"
  icon?: boolean
  closable?: boolean
  onClose?: () => void
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line no-undef, @typescript-eslint/no-explicit-any
  title?: React.ReactElement<React.ComponentProps<React.ComponentType<any>>> | string
  content?: Node
  ttl?: number
}

const defaultNoticeOptions = {
  type: "info",
  icon: true,
  closable: false,
  onClose: null,
  title: undefined,
  content: null,
  ttl: null,
} as const

export const setNotice = (options: NoticeOptions): NoticeAction => ({
  type: NOTICE_SET,
  /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
   * v0.118.0. To view the error, delete this comment and run Flow. */
  // @ts-expect-error: Flow to TS migration.
  notice: {
    ...defaultNoticeOptions,
    ...options,
  },
})

export const clearNotice = (id?: string): NoticeAction => ({
  type: NOTICE_CLEAR,
  id,
})
